import { Skeleton, Tooltip } from "antd";
import { styled } from "styled-components";
import { useEffect, useState } from "react";
import { ISearchPayload, scrollBarStyles } from "@dataone/lib";
import { CheckMarkSimpleIcon, ClipboardIcon } from "@dataone/icons";

interface TextResponseProps {
  response: Partial<ISearchPayload>;
  showTextDetails: boolean;
  toggleShowTextDetails: (value: boolean) => void;
}
function TextResponse({
  response,
  showTextDetails,
  toggleShowTextDetails,
}: TextResponseProps) {
  const [isThreePoints, setIsThreePoints] = useState(false);
  const [textCopied, setTextCopied] = useState(false);
  const handleMouseEnter = () => {
    if (isThreePoints) {
      toggleShowTextDetails(true);
    }
  };
  const handleMouseLeave = () => {
    toggleShowTextDetails(false);
  };
  const handleClipboardClick = (description: string) => {
    const textToCopy = `${description} `;
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    setTextCopied(true);
    setTimeout(() => {
      setTextCopied(false);
    }, 3000);
  };
  useEffect(() => {
    const textDescElement = document.querySelector(".text-desc");
    if (textDescElement) {
      setIsThreePoints(
        textDescElement.scrollHeight > textDescElement.clientHeight
      );
    }
  }, []);
  return (
    <StyledContent>
      <div onMouseLeave={handleMouseLeave}>
        <h5 style={{ padding: "10px" }}>The Essentials</h5>
        <div className="msg">
          <StyledDescription $showTextDetails={showTextDetails}>
            {response?.summary !== undefined ? (
              <>
                <StyledResponce>
                  {showTextDetails ? (
                    <div className="text-desc-details">{response?.summary}</div>
                  ) : (
                    <div onMouseEnter={handleMouseEnter} className="text-desc">
                      {response?.summary || "No summary found"}
                    </div>
                  )}
                </StyledResponce>
                <div className="copy-icon">
                  <Tooltip
                    placement="bottom"
                    title={<span style={{ fontSize: "12px" }}>Copy</span>}
                    overlayStyle={{ maxWidth: "300px" }}
                  >
                    <StyleCopiedIcon
                      onClick={() =>
                        handleClipboardClick(
                          response?.summary || "No summary found"
                        )
                      }
                      copied={textCopied}
                    >
                      {textCopied ? (
                        <>
                          <CheckMarkSimpleIcon />
                        </>
                      ) : (
                        <>
                          <ClipboardIcon />
                        </>
                      )}
                    </StyleCopiedIcon>
                  </Tooltip>
                </div>
              </>
            ) : (
              <>
                <Skeleton.Input
                  active
                  block
                  size="small"
                  style={{ marginBlock: "15px" }}
                />
                <Skeleton.Input
                  active
                  block
                  size="small"
                  style={{ maxWidth: "300px" }}
                />
              </>
            )}
          </StyledDescription>
        </div>
      </div>
    </StyledContent>
  );
}

export default TextResponse;

const StyledContent = styled.div`
  display: flex;
  flex-direction: row;
  > div {
    flex: 1;
  }
  h5 {
    margin: 0;
  }
  .msg {
    margin-top: 17px;
  }
`;

const StyledDescription = styled.div<{ $showTextDetails: boolean }>`
  height: ${(props) => (props.$showTextDetails ? "145px" : "115px")};
  transition: height 0.4s ease-in-out;
  position: relative;
  .text-desc {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }
  .text-desc-details {
    overflow-y: auto;
    height: 95px;
    ${scrollBarStyles}
  }
  .copy-icon {
    direction: rtl;
    display: flex;
    margin-top: -33px;
    margin-right: 10px;
  }
  span {
    color: #040726;
    font-size: 23px;
    font-weight: 400;
    line-height: 50px;
    letter-spacing: -0.375px;
  }
`;

const StyleCopiedIcon = styled.div<{ copied: boolean }>`
  cursor: pointer;
  font-size: ${({ copied }) => (copied ? "25px" : "15px")};
  color: #040726;
  display: flex;
  margin-left: 40px;
  width: 25px;
  height: 25px;
  align-items: center;
`;

const StyledResponce = styled.div`
  border-radius: 10px;
  background: #eff1fd;
  padding: 15px 12px 30px 20px;
  color: #040726;
  font-size: 13px;
  font-weight: 400;
  line-height: 33px;
  letter-spacing: -0.3px;
`;
